import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('list-meeting-room/index', {params});
    },
    getMeetingRoom(params) {
        return Service().get('list-meeting-room/get-list-meeting-room', {params});
    },
    show(id) {
        return Service().get('list-meeting-room/show/'+id);
    },
    create(params) {
        return Service().post('list-meeting-room/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('list-meeting-room/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('list-meeting-room/delete/'+id);
    },
}